import React from 'react';

export interface TrustedByProps {
  firmNames?: string[];
  peBackedReviewQuote?: string;
}

export default function TrustedBy({
  firmNames = [],
  peBackedReviewQuote = '',
}: TrustedByProps) {
  return (
    <div className="relative rounded-[14px] bg-[#132543] px-[32px] py-[26px]">
      <p className="font-['Open_Sans',sans-serif] text-[13px] font-semibold leading-[20px] text-[#AB9151]">
        Trusted By Top PE Firms Like
      </p>

      {firmNames.length > 0 && (
        <div className="mt-[14px] flex flex-wrap items-center gap-x-[28px] gap-y-[12px]">
          {firmNames.slice(0, 6).map((name, idx) => (
            <p
              key={`${name}-${idx}`}
              className="font-['Roboto_Slab',serif] text-[16px] font-bold leading-[22px] text-white"
            >
              {name}
            </p>
          ))}
        </div>
      )}

      {!!peBackedReviewQuote && (
        <div className="mt-[20px] border-t border-white/25 pt-[20px]">
          <p className="font-['Open_Sans',sans-serif] text-[13px] font-semibold leading-[20px] text-[#AB9151]">
            PE-Backed Review
          </p>

          <p className="mt-[10px] mb-0 font-['Open_Sans',sans-serif] text-[14px] font-normal italic leading-[22.75px] text-white">
            {peBackedReviewQuote}
          </p>
        </div>
      )}

    </div>
  );
}
